/**
 * Petite palette de couleurs stables pour les espaces du forum UC-16/17 (voir
 * core/services/community-forum.service.ts) — un espace/tag garde toujours la même couleur,
 * dérivée de son code plutôt que d'une association arbitraire figée à maintenir.
 */
export interface ChannelStyle {
  bg: string;
  fg: string;
  dot: string;
}

const PALETTE: ChannelStyle[] = [
  { bg: 'var(--surface-primary-tint)', fg: 'var(--pnud-bleu)', dot: 'var(--pnud-bleu)' },
  { bg: 'rgb(228,243,250)', fg: 'rgb(6,120,172)', dot: 'rgb(6,120,172)' },
  { bg: 'rgb(233,244,228)', fg: 'rgb(58,122,43)', dot: 'rgb(58,122,43)' },
  { bg: 'rgb(251,243,222)', fg: 'rgb(138,100,20)', dot: 'rgb(138,100,20)' },
  { bg: 'rgb(250,228,231)', fg: 'rgb(176,29,48)', dot: 'rgb(176,29,48)' },
];

/** Couleur stable par code région/secteur, dérivée de son hash plutôt que d'une association arbitraire figée. */
export function styleForCode(code: string): ChannelStyle {
  let hash = 0;
  for (const char of code) hash = char.charCodeAt(0) + ((hash << 5) - hash);
  return PALETTE[Math.abs(hash) % PALETTE.length];
}
